import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_PRICING } from "@/lib/pricing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null;
let inflight = null;

export const fetchPricing = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = axios
      .get(`${API}/pricing`)
      .then((r) => (cached = r.data))
      .catch(() => DEFAULT_PRICING)
      .finally(() => (inflight = null));
  }
  return inflight;
};

export const invalidatePricing = () => { cached = null; };

/** Live pricing config from the backend (admin-editable). Falls back to bundled defaults until loaded. */
export function usePricing() {
  const [pricing, setPricing] = useState(cached || DEFAULT_PRICING);
  useEffect(() => {
    let alive = true;
    fetchPricing().then((p) => alive && setPricing(p));
    return () => { alive = false; };
  }, []);
  return pricing;
}
